import { render, staticRenderFns } from "./ThirdPartyDetails.vue?vue&type=template&id=1d330ccc&"
import script from "./ThirdPartyDetails.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports